import React from 'react'
import moment from "moment";
import style from './ExamResult.module.css';
import TPTExamInstruction from '../../student/TPTExamInstruction';

const QuestionPaperTPT = ({ exam, TPTQuestions }) => {
    const getTopicEntries = () =>
        Object.entries(exam.topics || {})
            .map(([subject, topics]) => [subject, Array.isArray(topics) ? topics.filter(Boolean) : []])
            .filter(([, topics]) => topics.length > 0);

    const midIndex = Math.ceil(TPTQuestions.length / 2);
    const leftQuestions = TPTQuestions.slice(0, midIndex);
    const rightQuestions = TPTQuestions.slice(midIndex);
    return (
        <div className='times-font'>
            <div className='row' style={{ border: '1px solid black', display: 'flex', alignItems: 'center' }}>
                <div className='col-4 d-flex justify-content-center'>
                    <img src='/assets/images/monoarclogo2.jpeg' width='95%' alt='logo' className='my-3' />
                </div>
                <div
                    className='col-5 d-flex flex-column justify-content-center text-center'
                    style={{ borderRight: '1px solid black', borderLeft: '1px solid black', alignSelf: 'stretch', }}
                >
                    <h3 className='fw-bold'>{exam.courseName}</h3>
                </div>
                <div className='col-3 d-flex flex-column justify-content-center fw-bold'>
                    <span>NEET UG</span>
                    <span>{exam.className}</span>
                    <span>Date : {moment(exam.startDate).format('DD MMMM YYYY')}</span>
                </div>
            </div>
            <div className='row' style={{borderRight: '1px solid black', borderLeft: '1px solid black'}}>
                <h4 className="text-center py-1 fw-bold" style={{ borderBottom: '1px solid black' }}>{exam.examName}</h4>
                <div className='d-flex justify-content-between'>
                    <span>Marks : 80</span><span>Time : 20 mins</span>
                </div>
                {getTopicEntries().length > 0 && (
                    <div style={{ borderTop: '1px solid black', padding: '5px' }}>
                        <strong>Topics Included :</strong>
                        {getTopicEntries().map(([subject, topics]) => (
                            <div key={subject}>
                                <span className="fw-bold">{subject}: </span>
                                <span>{topics.join(", ")}</span>
                            </div>
                        ))}
                    </div>
                )}
                <div style={{ borderTop: '1px solid black',borderBottom: '1px solid black', padding: '5px' }}>
                    <strong>Important Instructions :</strong>
                    <TPTExamInstruction/>
                </div>
            </div>
            <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black' }}>
                {TPTQuestions.map((q, i) => (
                    <div key={i} className={`px-1 question ${style.questionPaper}`}>
                        <div className="d-flex"
                            dangerouslySetInnerHTML={{
                                __html: `<span class='mr-2 fw-bold fs-6'>${i + 1}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                            }}
                        >
                        </div>
                        <div className="d-flex flex-wrap">
                            {q.options.map((o, idx) => (
                                <span key={idx} className="ms-4 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<p class='mr-2'>(${idx + 1})</p> ${o}`
                                    }}
                                >
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {/* <div className="d-flex">
                <div className='w-50 pr-2' style={{ borderRight: '1px solid black' }}>
                    <div>
                        {leftQuestions.map((q, i) => (
                            <div key={i} className={`mb-2 ${style.questionPaper}`}>
                                <div className="mb-2 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>${i + 1}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                    }}
                                >
                                </div>
                                {q.options.map((o, idx) => (
                                    <span key={idx} className="mx-3 d-flex"
                                        dangerouslySetInnerHTML={{
                                            __html: `<p class='mr-2'>(${idx + 1})</p> ${o}`
                                        }}
                                    >
                                    </span>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w-50 pl-3">
                    <div>
                        {rightQuestions.map((q, i) => (
                            <div key={i} className={`mb-2 ${style.questionPaper}`}>
                                <div className="mb-2 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>&nbsp;&nbsp;${midIndex + i + 1}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                    }}
                                >
                                </div>
                                {q.options.map((o, idx) => (
                                    <span key={idx} className="mx-3 d-flex"
                                        dangerouslySetInnerHTML={{
                                            __html: `<p class='mr-2'>(${idx + 1})</p> ${o}`
                                        }}
                                    >
                                    </span>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default QuestionPaperTPT
